import { Typography } from 'antd';
import styles from './index.module.scss';

type TextErrorProps = {
  msg: string;
  qaSelector?: string;
  [key: string]: any;
};

function TextError({ msg, qaSelector, ...rest }: TextErrorProps) {
  return (
    <Typography.Text
      className={styles.container}
      {...rest}
      data-qa-selector={qaSelector}
    >
      {msg}
    </Typography.Text>
  );
}

export default TextError;
